import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon';
import { useAppSelector } from '../../store/store';
import { useSystemNotification } from '../../common/providers/SystemNotificationProvider/SystemNotificationProvider';

import styles from './SystemNotification.module.scss';

export const SystemNotification = () => {
  const auth = useAppSelector((state) => state.userSlice.auth);
  const { messages, updateOpenStatus } = useSystemNotification();
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    if (auth?.value?.loggedIn) {
      showNextMessage();
    } else {
      setIsFadingOut(true);
    }
  }, [auth, messages]);

  const showNextMessage = () => {
    const nextMessageIndex = messages.findIndex((msg) => msg.isOpen);
    if (nextMessageIndex !== -1) {
      setCurrentMessageIndex(nextMessageIndex);
      setIsVisible(true);
      setIsFadingOut(false);
    } else {
      setIsFadingOut(true);
    }
  };

  const handleClose = () => {
    setIsFadingOut(true);
    setTimeout(() => {
      const currentKey = messages[currentMessageIndex]?.key;
      if (currentKey) {
        updateOpenStatus(currentKey, false);
      }
      showNextMessage();
    }, 300);
  };

  if (!isVisible || messages.length === 0) return null;

  const currentMessage = messages[currentMessageIndex];

  return (
    <div className={clsx(
      styles.container,
      isFadingOut ? styles.hidden : styles.visible
    )}>
      <Icon name="information" size="32px" />
      <div className={styles.message}>{currentMessage?.message}</div>
      <Icon className={styles.close_icon} name="close-16" onClick={handleClose} size="16px" color={'var(--close-icon-color)'} />
    </div>
  );
};
